import { Tooltip } from "@mui/material";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/dropdown-menu";

export const DocumentActionsMenu = ({
  title,
  onEdit,
  editLabel = "Rediger ordre",
  onDelete,
  disabledReason,
}: {
  title: string;
  onEdit?: () => void;
  editLabel?: string;
  onDelete: () => void;
  disabledReason?: string;
}) => {
  const trigger = (
    <button
      type="button"
      disabled={!!disabledReason}
      aria-label={`Handlinger for ${title}`}
      title="Dokumenthandlinger"
      className="inline-flex size-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:pointer-events-none disabled:opacity-40 data-[state=open]:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-100 dark:data-[state=open]:bg-gray-800"
    >
      <MoreHorizontal size={17} aria-hidden="true" />
    </button>
  );
  if (disabledReason) {
    return (
      <Tooltip arrow describeChild title={disabledReason}>
        <span className="inline-flex" tabIndex={0}>
          {trigger}
        </span>
      </Tooltip>
    );
  }
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[1400] w-44 rounded-lg">
        {onEdit && (
          <>
            <DropdownMenuItem onSelect={onEdit}>
              <Pencil size={14} aria-hidden="true" />
              {editLabel}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem
          onSelect={onDelete}
          className="text-red-600 focus:bg-red-50 focus:text-red-600 dark:text-red-400 dark:focus:bg-red-950/40 dark:focus:text-red-400"
        >
          <Trash2 size={14} aria-hidden="true" />
          Slett dokument
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
